const dice = (
  howManyFaces = 2,
  howManyDice = 1,
  random = Math.random,
): number => {
  const roll = () => Math.ceil(random() * howManyFaces)

  let gross = roll()
  let rolls = 1

  while (rolls < howManyDice) {
    gross += roll()
    rolls += 1
  }

  return gross
}

export default dice
